module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/western_chef_male-663b3e65ebedd42a678da775afc7468a.webp";